import src from '/Users/huynhducduy/workspace/innosearch/innosearch-fe/interface/src/assets/food/hero-background-mobile-1.25x.jpg?url';

export default {
  lqip: `data:image/jpeg;base64,UklGRsIAAABXRUJQVlA4ILYAAADwBACdASoQACAAPm0skkWkIqGYBABABsS2AE6ZQjgRYFCAlgACj+a+a8nkhxQAtCwA/usw+YjgvI2R1ypwqS/rOc+HJeGnx730HzLJSKbgRALXj4SQgbufqP/hWwIn1nR/oVvSGrPRSKxeSDrvTZo81Nj8yl7ek2u0Xa4VMMrp5m0oeyAptufvyu6Wk1nnH/cl69yyka7QmOr++y50yZgQw0mqEXQC0Z5+kBksXWtyIdxwK4AAAA==`,
  src,
  width: 470,
  height: 945,
};
			